// Front views of the vehicles, for the rear-view mirror (a car behind you shows its nose).
// Same 4 shades as the rear views: "." transparent, "#" darkest, "@" dark, "+" light, "o" lightest.
// Index = vehicle category (0 formula, 1 rally car, 2 bike, 3 kart). Each has the same width as its rear view, so it scales the same way.
function painter(W: number, H: number) {
  const g = Array.from({ length: H }, () => Array(W).fill("."));
  const rect = (x: number, y: number, w: number, h: number, ch: string) => {
    for (let j = y; j < y + h; j++) for (let i = x; i < x + w; i++) if (i >= 0 && i < W && j >= 0 && j < H) g[j][i] = ch;
  };
  const sym = (x: number, y: number, w: number, h: number, ch: string) => (rect(x, y, w, h, ch), rect(W - x - w, y, w, h, ch));
  return { rect, sym, rows: () => g.map((r) => r.join("")) };
}

function formulaFront(): string[] {
  const P = painter(25, 12);
  P.rect(3, 0, 19, 1, "#"); P.rect(4, 1, 17, 1, "+"); P.sym(3, 0, 1, 3, "#"); // rear wing seen over the driver, with its end plates
  P.rect(10, 2, 5, 3, "@"); P.rect(10, 2, 5, 1, "#"); P.rect(11, 3, 3, 1, "o"); // helmet and visor
  P.rect(9, 4, 7, 1, "#"); // halo
  P.rect(7, 5, 11, 4, "@"); P.rect(7, 5, 11, 1, "#"); P.rect(9, 6, 7, 1, "+"); // airbox and sidepods
  P.sym(0, 3, 5, 7, "#"); P.sym(1, 5, 1, 1, "o"); P.sym(1, 7, 1, 1, "o"); // front tyres and their tread marks
  P.sym(5, 6, 3, 1, "#"); // suspension arms
  P.rect(10, 8, 5, 2, "@"); P.rect(11, 9, 3, 1, "#"); // nose cone
  P.rect(1, 10, 23, 1, "+"); P.rect(0, 11, 25, 1, "#"); P.sym(0, 9, 1, 3, "#"); // front wing and its end plates
  return P.rows();
}
function stockFront(): string[] {
  const P = painter(29, 14);
  P.rect(7, 0, 15, 5, "#"); P.rect(8, 1, 13, 3, "o"); P.rect(13, 1, 3, 1, "+"); P.rect(9, 0, 2, 1, "+"); P.rect(13, 0, 3, 1, "+"); P.rect(18, 0, 2, 1, "+"); // roof, windscreen and roof lamps
  P.rect(2, 5, 25, 2, "@"); P.rect(2, 5, 25, 1, "#"); P.sym(7, 5, 2, 1, "+"); // bonnet and its driving lights
  P.rect(1, 7, 27, 4, "@"); P.sym(1, 7, 1, 4, "#"); // front face
  P.sym(3, 7, 5, 2, "o"); // headlights
  P.rect(11, 8, 7, 2, "#"); P.rect(12, 8, 5, 1, "+"); // grille
  P.rect(1, 11, 27, 1, "#"); P.rect(3, 10, 23, 1, "#"); // bumper
  P.sym(0, 9, 4, 5, "#"); P.rect(4, 13, 21, 1, "#"); // tyres
  return P.rows();
}
function bikeFront(): string[] {
  const P = painter(15, 17);
  P.rect(5, 0, 5, 1, "#"); P.rect(4, 1, 7, 3, "#"); P.rect(5, 2, 5, 1, "o"); // helmet and visor
  P.rect(2, 4, 11, 1, "#"); P.rect(3, 5, 9, 4, "@"); // shoulders and fairing
  P.rect(6, 6, 3, 2, "o"); // headlight
  P.sym(0, 4, 2, 4, "#"); P.rect(0, 6, 15, 1, "#"); // arms on the handlebars
  P.sym(2, 9, 2, 3, "#"); // knees
  P.rect(6, 9, 3, 2, "#"); // fork
  P.rect(5, 11, 5, 6, "#"); P.rect(7, 12, 1, 1, "o"); P.rect(7, 14, 1, 1, "o"); // front tyre
  return P.rows();
}
function kartFront(): string[] {
  const P = painter(19, 11);
  P.rect(7, 0, 5, 3, "#"); P.rect(8, 1, 3, 1, "o"); // helmet and visor
  P.rect(5, 3, 9, 2, "@"); P.rect(5, 3, 9, 1, "#"); // shoulders
  P.rect(5, 5, 9, 3, "@"); P.rect(7, 6, 5, 1, "+"); // nose fairing and number plate
  P.sym(0, 4, 3, 6, "#"); P.sym(1, 6, 1, 1, "o"); // front tyres
  P.rect(3, 9, 13, 1, "+"); P.rect(3, 10, 13, 1, "#"); // bumper bar
  return P.rows();
}
export const FRONT_DEFAULTS: string[][] = [formulaFront(), stockFront(), bikeFront(), kartFront()];
